import { MoreOutlined } from "@ant-design/icons";
import TableUi from "../../../../../../atoms/StaticTable";
import Filters from "./Filters";
import { Button, Image, TableColumnsType, Tag } from "antd";
import Dropdown from "antd/es/dropdown/dropdown";
import CancelIcon from "../../../../../../atoms/CustomIcons/CancelIcon";
import { useState } from "react";
import ConfirmIcon from "../../../../../../atoms/CustomIcons/ConfirmIcon";
import { ContractWOType } from "../../../../ducks/types";
import {
  getValueBeforeUnderscore,
  WORK_ORDER_STATUS,
} from "../../../../../../config/utils";
import EmptyCard from "../../../../../../atoms/EmptyCard";

interface PropsType {
  contractWOData: ContractWOType[] | null | undefined;
}

export default function TabWorkOrders(props: PropsType) {
  const { contractWOData } = props;
  const location = window.location.pathname;
  const pathSegments = location.split("/");

  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [archived, isArchived] = useState(false);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button type="text" className="no-hover" icon={<ConfirmIcon />}>
          Change status to...
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button type="text" className="no-hover" icon={<CancelIcon />}>
          Cancel work order
        </Button>
      ),
    },
  ];

  const statusClassMap: Record<string, string> = {
    IN_PROGRESS: "approval_pending_tag",
    OPEN: "grey_tag",
    COMPLETED: "accepted_tag",
    SCHEDULED: "sent_tag",
    CLOSED: "cancelled_wo_tag",
    CANCELED: "cancelled_wo_tag",
    APPROVAL_PENDING: "approval_pending_tag",
    CONFIRMATION_PENDING: "in_progress_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Work order",
      dataIndex: "name",
      width: 220,
      render: (text) => text ?? "-",
      fixed: "left",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 170,
      render: (text) => {
        const cls = statusClassMap[text] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {WORK_ORDER_STATUS[text as keyof typeof WORK_ORDER_STATUS]}
          </Tag>
        );
      },
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
    // {
    //   title: "Visit",
    //   dataIndex: "no_of_visits",
    //   width: 140,
    //   render: (text) => (text ? text : "-"),
    //   sorter: (a, b) => a?.no_of_visits?.localeCompare(b?.no_of_visits),
    // },
    {
      title: "Service line",
      dataIndex: "service_line_name",
      width: 270,
      render: (text, record) => {
        return text ? (
          <Tag
            className={`${getValueBeforeUnderscore(
              record?.service_line_color
            )} default_tag`}
          >
            {text}
          </Tag>
        ) : (
          "-"
        );
      },
      sorter: (a, b) =>
        a?.service_line_name?.localeCompare(b?.service_line_name),
    },
    {
      title: "Performed by",
      dataIndex: "performed_by_crew",
      width: 140,
      render: (text) => (text ? "Crew" : "Crew"),
      sorter: (a, b) =>
        a?.performed_by_crew?.localeCompare(b?.performed_by_crew),
    },
    {
      title: "Crew/Subcontractor",
      dataIndex: "crew_or_contractor_name",
      width: 270,
      render: (text) => (text ? <Tag>{text}</Tag> : "-"),
      sorter: (a, b) =>
        a?.crew_or_contractor_name?.localeCompare(b?.crew_or_contractor_name),
    },
    {
      title: "Estimated hrs",
      dataIndex: "estimated_hrs",
      width: 150,
      align: "right",
      sorter: (a, b) => a?.estimated_hrs - b?.estimated_hrs,
      className: "right-aligned-sorter",
      render: (value: number) =>
        value ? (
          <span>
            {value.toFixed(2)} <span style={{ color: "#6C7478" }}>h</span>
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Scheduled hrs",
      dataIndex: "scheduled_hrs",
      width: 150,
      render: (text) => (text ? text.toFixed(2) : "-"),
      align: "right",
      sorter: (a, b) => a?.scheduled_hrs - b?.scheduled_hrs,
      className: "right-aligned-sorter",
    },
    {
      title: "Actual hrs",
      dataIndex: "actual_hrs",
      width: 150,
      render: (text) => (text ? text.toFixed(2) : "-"),
      align: "right",
      sorter: (a, b) => a?.actual_hrs - b?.actual_hrs,
    },
    {
      title: "Scheduled dates",
      dataIndex: "scheduled_dates",
      width: 195,
      render: (text) => text ?? "-",
      sorter: (a, b) => a?.scheduled_dates - b?.scheduled_dates,
    },
    // {
    //   title: "Progress",
    //   dataIndex: "progress_perc",
    //   width: 195,
    //   render: (text) => text ?? "-",
    //   sorter: (a, b) => a?.progress_perc - b?.progress_perc,
    // },
    // {
    //   title: "Efficiency",
    //   dataIndex: "efficiency_perc",
    //   width: 195,
    //   render: (text) => {
    //     return <Tag className="grey_tag">{text}</Tag>;
    //   },
    //   sorter: (a, b) => a?.efficiency_perc - b?.efficiency_perc,
    // },
    // {
    //   title: "Estimated labor cost",
    //   dataIndex: "estimated_labor_cost",
    //   width: 180,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.estimated_labor_cost - b?.estimated_labor_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Actual labor cost",
    //   dataIndex: "actual_labor_cost",
    //   width: 180,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.actual_labor_cost - b?.actual_labor_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Estimated material cost",
    //   dataIndex: "estimated_material_cost",
    //   width: 220,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.estimated_material_cost - b?.estimated_material_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Actual material cost",
    //   dataIndex: "actual_material_cost",
    //   width: 195,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.actual_material_cost - b?.actual_material_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Projected revenue",
    //   dataIndex: "projected_revenue",
    //   width: 180,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.projected_revenue - b?.projected_revenue,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Earned revenue",
    //   dataIndex: "earned_revenue",
    //   width: 180,
    //   render: (text) =>
    //     text ? Number(text?.toFixed(2)).toLocaleString() : "-",
    //   align: "right",
    //   sorter: (a, b) => a?.earned_revenue - b?.earned_revenue,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Date completed",
    //   dataIndex: "date_completed",
    //   width: 170,
    //   render: (text) => text ?? "-",
    //   align: "right",
    // },

    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              // setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      ),
    },
  ];

  return (
    <div className="dashboard-tab">
      {(contractWOData?.length ?? 0) > 0 ? (
        <TableUi
          columns={columns}
          data={{
            count: contractWOData?.length ?? 0,
            data: contractWOData || [],
          }}
          filters={
            <Filters
              setFilters={setFilters}
              filters={filters}
              archived={archived}
              isArchived={isArchived}
              companyId={companyId}
            />
          }
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          // onClickRow={onClickRow}
        />
      ) : (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={282}
            title="There are no work orders."
            description=""
            image="/images/empty-icons/no-active.svg"
            // btnText="Create change order"
            // btnLink={`/change-orders/add`}
          />
        </div>
      )}
    </div>
  );
}
